import logo from "../../global/images/haravan-logo.svg";
import {Dropdown, Icon} from "@haravan/react-components";
import {getUrlAccount} from "../../global/utils/functions";
import {useSelector} from "react-redux";
import {selectUser} from "../../screens/auth/services/auth_slice";
import {useNavigate} from 'react-router-dom';
import {PermissionRepository} from "../../repositories";
import "./header.css";

export const Header = () => {
    const user = useSelector(selectUser);

    const navigate = useNavigate();

    const onClickViewProfile = () => {
        window.open(getUrlAccount(), "_blank");
    };

    const onClickLogout = () => {
        PermissionRepository.LogOut().then(() => 
            window.location.href = "./signout-callback-oidc"
        );
    };

    const onClickHaravanIcon = () => {
        navigate("/shops");
    };
    const content = (
        <div className="header-modal shadow-lg rounded ">
            {
                user && <div className="account-info">
                <strong className="font-weight-bold m-0">{user.profile.name}</strong>
                <p className="account-infor-email m-0">{user.profile.email}</p>
              </div>
            }
            <div className="account-action">
                <li className="account-action-item font-weight-normal" onClick={onClickViewProfile}>
                    <Icon type="userBorder" theme="regular" className="m-2"/> <span>Tài khoản</span>
                </li>
                <li className="account-action-item font-weight-normal " onClick={onClickLogout}>
                    {" "}
                    <Icon type="logout" theme="regular" className="m-2"/> <span>Đăng xuất</span>{" "}
                </li>
            </div>
        </div>
    );
    const getSeededColor = (seed) => {
        const colors = [
            '#22a7ff', // Xanh dương
            '#8e44ad', // Tím (để tạo điểm nhấn, tương tự nút "thao tác")
            '#f1c40f', // Vàng (tạo sự nổi bật, tương tự cam/đỏ)
            '#e67e22', // Cam
            '#95a5a6', // Xám
            '#2c3e50', //
        ];

        let hash = 0;
        for (let i = 0; i < seed.length; i++) {
            hash = seed.charCodeAt(i) + ((hash << 5) - hash);
        }

        const index = Math.abs(hash) % colors.length;
        return colors[index];
    }

    const getLastCharName = (fullName) => {
        if (!fullName) return '';
        const nameParts = fullName.trim().split(' ');
        const lastName = nameParts[nameParts.length - 1];
        return lastName.charAt(0).toUpperCase();
    };

    const lastCharName = getLastCharName(user?.profile?.name || '');

    return user ? (
        <div className="header-wapper d-flex justify-content-between">
            <div className="header-logo">
                <a onClick={onClickHaravanIcon}><img src={logo} alt="" className="header-log-img"/></a>
            </div>
            <div className="header-user cus-pointer">
                <Dropdown content={content}>
                    <div className=" d-flex justify-content-between  align-items-center p-2">
                        <h5 className="m-0 text-white header-title">{user.profile.name}</h5>
                        <div className="header-logo-account" style={{
                            backgroundColor: getSeededColor(lastCharName)
                        }}>
                            {user.profile.picture ? <img src={user.profile.picture} alt="" style={{height: "40px"}}/> :
                                <span style={{
                                    color: 'white',
                                    fontSize: '1.2rem',
                                    fontWeight: 'bold'
                                }}>{lastCharName}</span>}
                        </div>
                    </div>
                </Dropdown>
            </div>
        </div>
    ) : <></>;
};
